import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.paypal_deposit,
    (paypal_deposit) => {
        return {
            stage: paypal_deposit.stage
        }
    }
)